import { makeItemId } from '../functions/dashboard-chart.functions';
import type {
  DashboardCanvasLayout,
  DashboardCardConfig,
  DashboardCardItem,
  DashboardChartItem,
  DashboardChartSourceKey,
  DashboardChartType,
  DashboardMetricItem,
  DashboardMetricKey,
  DashboardWidget,
  DateRangePreference,
  OrganizationsPreference,
  ScopePreference,
  UserPreferences,
} from '../types';
import { DEFAULT_FAVORITE_SCOPE_TAG_IDS, DEFAULT_FAVORITE_VIEW_IDS } from './views.seed';

const card = (
  id: string,
  heading: string,
  items: ReadonlyArray<DashboardCardItem>,
  colSpan: number,
  rowSpan: number,
): DashboardWidget => ({
  id,
  kind: 'card',
  config: { heading, items } as DashboardCardConfig,
  colSpan,
  rowSpan,
});

const metricItem = (metricKey: DashboardMetricKey): DashboardMetricItem => ({
  kind: 'metric',
  id: makeItemId(),
  metricKey,
});

const chartItem = (
  sourceKey: DashboardChartSourceKey,
  chartType: DashboardChartType,
): DashboardChartItem => ({
  kind: 'chart',
  id: makeItemId(),
  sourceKey,
  chartType,
});

export const DEFAULT_DASHBOARD_LAYOUT: DashboardCanvasLayout = [
  card('default-grr', '', [metricItem('grr')], 3, 2),
  card('default-survey', '', [metricItem('survey-review-rating')], 3, 2),
  card('default-online', '', [metricItem('online-review-rating')], 3, 2),
  card('default-compset', '', [metricItem('compset-position')], 3, 2),
  card('default-trend', 'Trend Analysis', [chartItem('trend-analysis', 'line')], 8, 5),
  card('default-nps', 'Net Promoter Score', [chartItem('net-promoter-score', 'line')], 4, 5),
  card('default-sentiment', 'Sentiment', [chartItem('sentiment', 'donut')], 4, 5),
  card('default-ratings', 'Primary Service Ratings', [chartItem('service-ratings', 'bar')], 4, 5),
  card('default-competitor', 'Competitor Performance', [chartItem('competitor', 'bar')], 4, 5),
];

export const DEFAULT_DATE_RANGE: DateRangePreference = {
  presetId: 'last30',
  fromIso: '',
  toIso: '',
};

export const DEFAULT_SCOPE: ScopePreference = {
  selection: { kind: 'all' },
  favoriteViewIds: DEFAULT_FAVORITE_VIEW_IDS,
  favoriteTagIds: DEFAULT_FAVORITE_SCOPE_TAG_IDS,
  favoriteAccountIds: [],
};

export const DEFAULT_ORGANIZATIONS: OrganizationsPreference = {
  activeId: null,
  primaryId: null,
};

export const DEFAULT_USER_PREFERENCES: UserPreferences = {
  theme: 'system',
  dashboardLayout: DEFAULT_DASHBOARD_LAYOUT,
  dashboardOrder: [],
  dateRange: DEFAULT_DATE_RANGE,
  reports: [],
  tags: [],
  dashboardPresets: [],
  scope: DEFAULT_SCOPE,
  organizations: DEFAULT_ORGANIZATIONS,
  tableBuilderConfigs: [],
  chartBuilderConfigs: [],
  sidebarCollapsed: false,
  tableColumns: {},
};
